"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ascendingComparator = _interopRequireDefault(require("./ascendingComparator"));

var _sortByProperties = _interopRequireDefault(require("./sortByProperties"));

var sortBy = function sortBy(array, key) {
  var comparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ascendingComparator["default"];
  return (0, _sortByProperties["default"])(array, [{
    key: key,
    comparator: comparator
  }]);
};

var _default = sortBy;
exports["default"] = _default;